import { cx } from 'class-variance-authority';
import commonStyles from '@/app/(website)/commonStyles.module.scss';
import styles from './faq.module.scss';
import FAQAccordionList from './FAQAccordionList';
import type { FAQProps, FaqEntry } from './types';

const FAQ = ({
  header = 'Frequently asked questions',
  faq_entry = [],
  defaultOpenFirst = true,
  className
}: Readonly<FAQProps>) => {
  const entries: FaqEntry[] = Array.isArray(faq_entry) ? faq_entry : [];

  return (
    <section className={cx(commonStyles.sectionContent, styles.faq, className)}>
      <div className={styles.faqWrap}>
        <h2 className={commonStyles.sectionSubheadingH2}>{header}</h2>
        <FAQAccordionList
          entries={entries}
          defaultOpenFirst={defaultOpenFirst}
        />
      </div>
    </section>
  );
};

export default FAQ;
